const map = {
  // NC SOP管理
  instancetasklist: () => import('@/views/sopinstance/instancetask/index'),
  sopTaskTreelist: () => import('@/views/sopinstance/instancetask/stasktree'),
  sopinstanceTaskTreelist: () => import('@/views/sopinstance/instancetask/instancetasktree')
}

export default map
